export default "__VITE_ASSET__$5bOj6QW__"